import { createContext } from "react";
import { ValidateStatus } from "../interfaces/firmaInterfaces";

interface DefaultValuesInterface {
  certFile: File | null;
  keyFile: File | null;
  showPassword: Boolean;
  tipo_firmante: number | null;
  errorMessage: string[];
  loadingFirma: boolean;
  showCertificadosGuardados: boolean;
  statusFirma: ValidateStatus | null;
  successFirmado: boolean;
  addCerFile: (file: File) => void;
  addKeyFile: (file: File) => void;
  addTipoFirmante: (e: number) => void;
  handleClickShowPassword: () => void;
  handleMouseDownPassword: (event: React.MouseEvent<HTMLButtonElement>) => void;
  readCertificate: (file: File) => void;
  readPrivateKey: (file: File) => void;
  handleClickShowCerKeySave: (status: boolean) => void;
  startFinishFirmaAnticipada: () => void;
  handleAddCertSelected: (cer: { [x: string]: any }) => void;
  handleAddKeySelected: (key: { [x: string]: any }) => void;
}

const defaultValues: DefaultValuesInterface = {
  certFile: null,
  keyFile: null,
  showPassword: false,
  loadingFirma: false,
  showCertificadosGuardados: false,
  successFirmado: false,
  tipo_firmante: null,
  errorMessage: [],
  statusFirma: null,
  addCerFile: () => {},
  addKeyFile: () => {},
  addTipoFirmante: () => {},
  handleClickShowPassword: () => {},
  handleMouseDownPassword: () => {},
  readCertificate: () => {},
  readPrivateKey: () => {},
  handleClickShowCerKeySave: () => {},
  startFinishFirmaAnticipada: () => {},
  handleAddCertSelected: () => {},
  handleAddKeySelected: () => {},
};
export const FirmaElectronicaContext = createContext(defaultValues);
